import { Env } from '@/shared/config/environment';
import { HttpClient } from '@/shared/lib/http-client';

export const saveClientData = async(clientData) => {
  const response = await HttpClient.post(`${Env.server.mode}/clients`, clientData);

  return response.data;
};
